import * as React from 'react';
const AvatarContext = React.createContext({ size: 'default', shape: undefined });
export default AvatarContext;
